import { useTranslation } from 'react-i18next';
import { SimpleErrorModal } from './SimpleErrorModal';

export const NetworkErrorModal = () => {
  const { t } = useTranslation();

  return (
    <SimpleErrorModal
      title={t('network_issue_title')}
      description={t('network_issue_text')}
      buttonText={t('refresh_button')}
      buttonAction={() => window.location.reload()}
    />
  );
};
